import React from "react";
import Loadable from "react-loadable";

import DotSpinner from "@exo/dot-spinner";

const EasternEuropeMapLoader = Loadable.Map({
	loader: {
		MapComponent: () => import(/* webpackChunkName: "map" */ "genericComponents/Map"),
		europeMapObject: () => import(/* webpackChunkName: "map" */ "static/maps/jsMaps/easternEurope.js"),
		mapIndex: () => import(/* webpackChunkName: "map" */ "lib/maps/mapIndexEasternEurope.js"),
	},
	loading: DotSpinner,
	render(loaded, props) {
		const { actions } = props;
		const Map = loaded.MapComponent.default;
		const mapIndex = loaded.mapIndex.default;
		const europeMapObject = loaded.europeMapObject.default;

		return (
			<Map
				{...props}
				reactSimpleMaps={null}
				baseMapObject={europeMapObject}
				states={null}
				mapIndex={mapIndex}
				baseIcon={false} // Pass a tiny map svg/js object here, or false to disable
				// trigger remount between detailed and base maps (prevents awkward transition)
				key={props.mapHighlight ? "mapHighlight" : "baseMap"}
				mapHighlightDisabled={true}
				mapId="base"
				maxHeight={600} // 400 for US map
				moeMode={false}
				subtractFromHeight={100} // 360 for US map
				wideMap // true for US map
				// actions
				clearMap={actions.clearMap}
				clearMapPlay={actions.clearMapPlay}
				clickMap={actions.clickMap}
				hoverMap={actions.hoverMap}
				incrementMapPosition={actions.incrementMapPosition}
				setMapPosition={actions.setMapPosition}
				toggleMapPlay={actions.toggleMapPlay}
				unhoverMap={actions.unhoverMap}
				// --- Turn this stuff off without breaking ---
				dmaMap={false}
				filtering={false}
				mapHighlightDisabled={false} // no state maps OR clickable states
				mapCountyHighlight={false}
				mapCountyHighlightId={""}
				mapCountyHighlightColor={""}
				mapCountyHighlightTitle={""}
				mapCountyHighlightValue={""}
				// mapHighlight={false}
				// mapHighlightId={false}
				// mapHighlightGeoState={{}}
				mapHighlightColor={""}
				// mapHighlightDate={""}
				// mapHighlightTitle={""}
				// mapHighlightTitleReserved={""} // used to reinstate the map highlight when exiting countyHighlight mode
				// mapHighlightValue={""}
				// mapHighlightStoredText={""} // State share value to display in highlight mode
				mapPlaying={false} // false or string. 'playing' or 'stopped'. false is all state
				mapPosition={false}
			/>
		);
	},
});

export default EasternEuropeMapLoader;
